import { UpdateRetailerNetworkUserPolicy } from '@open-commerce/oc-authorization-policies';

import { useCan } from '@occc-app/App/PolicyBasedAccessControl';
import { Retailer_Network_User_Role } from '@occc/graphql';

import { useRetailerNetworkUserSelector } from '../../../retailer-network-context/use-retailer-network-user.selector';

export const useGetIsUserPermittedToEditRole = (
  networkId: string | undefined,
  targetUserRole: Retailer_Network_User_Role,
) => {
  const isUserPermittedTo = useCan();
  const { isRetailerNetworkSiteAdmin } = useRetailerNetworkUserSelector();
  const isTargetUserRetailerNetworkSiteAdmin =
    targetUserRole === Retailer_Network_User_Role.SiteAdmin;

  const isCurrentUserPermittedToEdit = isUserPermittedTo(UpdateRetailerNetworkUserPolicy('uuid'), {
    uuid: networkId,
  });

  if (!isCurrentUserPermittedToEdit) {
    return false;
  }

  if (isRetailerNetworkSiteAdmin && isTargetUserRetailerNetworkSiteAdmin) {
    return false;
  }

  return true;
};
